import React from "react";
import { Widget } from "@typeform/embed-react";
import "./Questionnaire.css";
function Questionnaire() {
  return <Widget id="EJdGvhj3" className="my-form" />;
}

export default Questionnaire;
